export function TimesheetSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/timesheet.svg'"></ng-include>`
    }
}